/* eslint-disable */
import React, { useState, useEffect, useRef, Fragment } from "react";
import {
    Card,
    Layout,
    Row,
    Col,
    Button,
    Input,
    message,
    Modal,
    Space,
    TimePicker,
    DatePicker,
    Form,
    Table,
    Select, Badge,
    Divider
} from "antd";
import {
    EditOutlined,
    MoreOutlined,
    ImportOutlined,
    DownloadOutlined,
    PrinterOutlined,
    QrcodeOutlined,
    CheckCircleOutlined,
  } from "@ant-design/icons";
import { Redirect } from "react-router-dom";
import Axios from "axios";
import moment from "moment";
import { url } from "../../config/global";
import { BarcodeOutlined } from "@ant-design/icons";
const { Search } = Input;
const { Content } = Layout;

const layout = {
    labelCol: {
        xs: 24,
        lg: 24,
        md: 24,
    },
    wrapperCol: {
        xs: 24,
        lg: 24,
        md: 24,
    },
};

function SPTransformBeforePaint(props) {
    const [selectedRowKeysData, setSelectedRowKeysData] = useState([]);
    const [selectedRowsData, setSelectedRowsData] = useState([]);
    const [beforePaintList, setbeforePaintList] = useState([]);
    const [page, setPage] = useState(1);
    const [dnExtProcess, setdnExtProcess] = useState([]);
    const [loading, setloading] = useState(false);
    const [loadingPrint, setloadingPrint] = useState(false);
    const [loadingDetail, setLoadingDetail] = useState(false);
    const [pageSize, setPagesize] = useState(10);

    const [failedData, setfailedData] = useState([]);
    const [oneTimeGet, setOneTimeGet] = useState(false);

    const [sort, setSort] = useState({
        sort: "created_at",
        order: "desc",
    });
    const [data, setData] = useState({
        ref_dn: null,
        lot_prod: null,
        dn_outgoing: null,
        item_after: null,
        kanban_no: [],
        scan_outgoing_id: null,
        qty: 0,
    });
    const [rowDetails, setRowDetails] = useState([]);
    const [keyword, setKeyword] = useState(null);
    const [orderDate, setOrderDate] = useState(null);
    const [dataHead, setDataHead] = useState([]);
    const [selectedId, setSelectedId] = useState("");
    const [dataDetail, setDataDetail] = useState([]);
    const [totalHead, setTotalHead] = useState(0);
    const [totalDetail, setTotalDetail] = useState(0);
    const [descInput, setDescInput] = useState([]);
    const [afterItemInput, setafterItemInput] = useState(null);
    const [pageDetail, setPageDetail] = useState(1);
    const [pageSizeDetail, setPagesizeDetail] = useState(10);
    const [perPageDetail, setPerPageDetail] = useState(10);
    const [refDNInput, setrefDNInput] = useState(null);
    const [refDNInputID, setrefDNInputID] = useState(null);
    const [failedModal, setFailedModal] = useState(false);
    const [submitTime, setsubmitTime] = useState(null);
    const [buttonAccess, setButtonAccess] = useState(null);
    const [generate, setGenerate] = useState([]);
    const [sortDetail, setSortDetail] = useState({
        sort: "updated_at",
        order: "descend",
      });
    const permissions =
        sessionStorage.getItem("permissions") &&
        JSON.parse(sessionStorage.getItem("permissions"));
    useEffect(() => {
        const pathname = window.location.pathname.split("/");
        const currentUrl = pathname[1];
        if (permissions) {
            const findPermission = permissions.find(
                (permission) => permission.url === currentUrl
            );
    
            const findChildPermission = permissions
                .map((child) => {
                    return child.children.find(
                        (grandChild) => grandChild.url === currentUrl
                    );
                })
                .filter((grandChild) => grandChild)[0];
    
            if (findChildPermission && findChildPermission.children) {
                if (findChildPermission.children) {
                    const findButtonAccessChildren = findChildPermission.children
                        .filter((x) => x !== null)
                        .filter((x) => x.permission_type === "button");
                    if (findButtonAccessChildren) {
                        setButtonAccess(findButtonAccessChildren.filter((x) => x !== null));
                    }
                }
            }
    
            if (findPermission && findPermission.children) {
                const findButtonAccess = findPermission.children.filter(
                    (x) => x.permission_type === "button"
                );
                if (findButtonAccess) {
                    setButtonAccess(findButtonAccess);
                }
            }
        }
    },[])
    useEffect(() => {
        getDNHead();
    }, [keyword, page, sort,orderDate]);
    const handleChangeDetails = (data) => {
        const index = data[data.length - 1];
        setRowDetails([index]);
        if (index) {
          const data2 = index.split(";");
          setSelectedId(data2[0]);
          getDataDetailDN(data2[0]);
        }
      };
      const handleTableChange = (pagination, filters, sorter) => {
        setPagesize(pagination.pageSize);
        setPage(pagination.current);
        setSort({
          sort: sorter.field,
          order: sorter.order,
        });
      };
    const handleChangeDetailsTable = (pagination, filter, sorter) => {
        setPageDetail(pagination.current);
        setPagesizeDetail(pagination.pageSize);
        setSortDetail({
          sort: sorter.field,
          order: sorter.order,
        });
        setPerPageDetail(pagination.pageSize);
    }
     const saveTransform = () => {
    setloading(true);
    Axios.post(
      `${url}/transformation-item/store-history`,
      {
        data_transform: dataTable,
        data_scanned: data_scanned,
        data_kanban: data_kanban,
        data:data,
        ref_outgoing
      },
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }
    )
      .then((res) => {
        setloading(false);
        Modal.success({
          title: "Success!",
          content: res.data.message,
        });
        resetAll();
      })
      .catch((err) => {
        // console.log(err.response.data);
            if (err.response) {
              if(err.response.data.err_data)
                {
                  setfailedData(err.response.data.err_data)
                  setFailedModal(true)
                  setsubmitTime(err.response.data.submit_time)
                }
              Modal.error({
                title: "Failed!",
                content: err.response.data.message,
              });
              // message.error(err.response.data.message);
              if (err.response.status === 422) {
                setError(err.response.data.errors);
              }
              if (err.response.status === 401) {
                sessionStorage.removeItem("token");
              }
            }
            setloading(false);
      }
      );

  }
      const renderColumnDetail = (item, index) => {
        // console.log('ROW','as')
        const columnsDetails = [
        
          {
            title: "Item Number After",
            dataIndex: "item_number_after",
            key: "item_number_after",
            sorter: true,
            width: 100,
          },
          {
            title: "Desc Item Number After",
            dataIndex: "desc_item_number_after",
            key: "desc_item_number_after",
            sorter: true,
            width: 100,
          },
          {
            title: "Unit of Measure After",
            dataIndex: "unit_of_measure",
            key: "unit_of_measure",
            sorter: true,
            width: 100,
          },
          {
            title: "Item Number Before",
            dataIndex: "item_number_before",
            key: "item_number_before",
            sorter: true,
            width: 100,
          },
          {
            title: "Desc Item Number Before",
            dataIndex: "desc_item_number_before",
            key: "desc_item_number_before",
            sorter: true,
            width: 100,
          },
          {
            title: "Model",
            dataIndex: "project",
            key: "project",
            sorter: true,
            width: 100,
          },
          {
            title: "Total Qty Kanban",
            dataIndex: "total_qty_kanban",
            key: "total_qty_kanban",
            sorter: true,
            width: 100,
          },
          {
            title: "Total  Kanban",
            dataIndex: "total_kanban",
            key: "total_kanban",
            sorter: true,
            width: 100,
          },
          
        ];


            return (
             
              <>
                <Row justify="end" gutter={[0, 20]}>
                  <Col></Col>
                </Row>
                <Row>
                  <Col xs={24}>
                    <Form component={false}>
                      <Table
                        scroll={{ x: 1500 }}
                        columns={columnsDetails}
                        rowKey={(data) => data._id}
                        loading={loadingDetail}
                        // dataSource={dns.data[index].details}
                        dataSource={dataDetail}
                        // size="small"
                        pagination={{
                          pageSize: perPageDetail,
                          current: pageDetail,
                          total: totalDetail,
                          showSizeChanger: true,
                          style: {
                            marginTop: "2rem",
                            marginBottom: 0,
                          },
                        }}
                        onChange={handleChangeDetailsTable}
                      />
                    </Form>
                  </Col>
                </Row>
              </>
            );
    }
    const getDataDetailDN = (dn_id) => {
        setLoadingDetail(true);
        setDataDetail([]);
        setTotalDetail(0);
        Axios.get(`${url}/dn-ext-process/get-details`, {
            params: {
                keyword:keyword,
                order_date:orderDate,
                dn_id:dn_id,
                perpage:50
            },
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
        }).then((res) => {
            setDataDetail(res.data.data);
            setTotalDetail(res.data.total);
            setLoadingDetail(false);
        }) .catch((err) => {
            
            setLoadingDetail(false);
            if (err.response) {
              setData({
                ...data,
                kanban_number: "",
              });
              Modal.error({
                title: "Failed!",
                content: err.response.data.message,
              });
              
              if (err.response.status == 401) {
                sessionStorage.removeItem("token");
              }
            }
          });
    }
    const getDNHead = () => {
        setloading(true);
        Axios.get(`${url}/dn-ext-process/get-data`, {
          params: {
           keyword:keyword,
           columns: [
            "dn_no",
            "purchase_order",
            "tgl_order",
            "tgl_delivery",
          ],
          filter_date:orderDate,
          page:page,
          perpage:pageSize,
          sort:sort.sort,
          order:sort.order,
          },
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }).then((res) => {
          setDataHead(res.data.data);
          setTotalHead(res.data.total);
          setloading(false);
        }) .catch((err) => {
            setloading(false);

          if (err.response) {
            setData({
              ...data,
              kanban_number: "",
            });
            Modal.error({
              title: "Failed!",
              content: err.response.data.message,
            });
            
            if (err.response.status == 401) {
              sessionStorage.removeItem("token");
            }
          }
        });
      };

    const closeModal = () => {
        setFailedModal(false);
    };
    
      const handleDatepicker = (value) => {
        if (value != null) {
          var date = moment(value).format("YYYY-MM-DD");
          
          setOrderDate(date);
        }
      };
      const handleSearch = (value) => {
        if (value != null) {
        
        
          setKeyword(value);
        }
      };
     
    const printAll = () => {
      setloadingPrint(true);
        Axios.post(
          `${url}/dn-ext-process/print-all`,
          {
            data: generate,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
          .then((res) => {
            setloadingPrint(false);
            Modal.success({
              title: "Success!",
              content: res.data.message,
            });
            getDNHead();
            window.open(res.data.filename);
           
          })
          .catch((err) => {
            // console.log(err.response.data);
                if (err.response) {
                 
                  Modal.error({
                    title: "Failed!",
                    content: err.response.data.message,
                  });
                  // message.error(err.response.data.message);
                  if (err.response.status === 422) {
                    setError(err.response.data.errors);
                  }
                  if (err.response.status === 401) {
                    sessionStorage.removeItem("token");
                  }
                }
                setloadingPrint(false);
          }
          );
    };


    const columns = [

        {
            title: "Status DN",
            dataIndex: "status_dn",
            sorter: true,
            render:(data,record) => {
            if(record.dn_no != '-')
            {
              return (<Badge count="COMPLETED"  style={{ backgroundColor: '#389e0d' }}/>)
            }
            else
            {
              return (<Badge count="ON PROGRESS"  style={{ backgroundColor: '#8c8c8c' }}/>)
            }
          },
        },
        {
            title: "Ref DN No",
            dataIndex: "ref_dn",
            sorter: true,
        },
        {
            title: "DN No",
            dataIndex: "dn_no",
            sorter: true,
        },
        {
            title: "Purchase Order",
            dataIndex: "purchase_order",
            sorter: true,
        },
        {
            title: "Supplier",
            dataIndex: "supplier_name",
            sorter: true,
            render: (index, record) => {
                return record.supplier_name+" (" + record.supplier_code + ") ";
            }
        },
        {
            title: "Tgl Delivery",
            dataIndex: "tgl_delivery",
            sorter: true,
        },
        {
            title: "Tgl Order",
            dataIndex: "tgl_order",
            sorter: true,
        },
        {
            title: "Status Print",
           render:(data,record) => {
            if(record.status_print == "PRINTED")
            {
              return (<Badge count="PRINTED"  style={{ backgroundColor: '#52c41a' }}/>)
            }
            else
            {
              return (<Badge count="NOT PRINT"  style={{ backgroundColor: '#ff4d4f' }}/>)
            }
          },
            sorter: false,
        },
        {
            title: "Dibuat Pada",
            dataIndex: "generated_at",
            sorter: true,
        },
    ];

    return (
        <Fragment>

            <Row>
                <Col xs={24}>
                    <Card
                        type="inner"
                        title=" Delivery Note External Process"
                        bodyStyle={{ padding: "0" }}
                        extra={moment(new Date()).format("DD MMMM YYYY")}
                    ></Card>
                </Col>
            </Row>
            <Content className="content">
                <Row>
                    <Col xs={24}>
                        <Card className="body-data">
                            <Form {...layout} layout="vertical" >
                                <Row>
                                    <Col  xs={24} md={12} lg={16}>
                                       
                                                <Button
                                                    loading={loadingPrint}
                                                    onClick={printAll}
                                                    type="primary"
                                                >
                                                    <PrinterOutlined />
                                                    Print All
                                                </Button>
                                         
                                    </Col>
                                    
                                    <Col xs={24} md={12} lg={8} className="align-right">
                                        <DatePicker
                                        placeholder="Delivery Date"
                                        onChange={(value) => handleDatepicker(value)}
                                        presetsWidth={60}
                                        />
                                        <Search
                                        placeholder="Search ..."
                                        onSearch={(value) => handleSearch(value)}
                                        />
                                    </Col>
                  </Row>
                  <Divider />
                                <Row>
                                    <Col xs={24} md={24} lg={24}>
                                        <Table
                                            scroll={{ x: 1400 }}
                                            columns={columns}
                                            rowSelection={{
                                                selectedRowKeys: selectedRowKeysData,
                                                type: "checkbox",
                                                onChange: (selectedRowKeys, selectedRows, record) => {
                                                  setSelectedRowsData(selectedRows);
                                                  setSelectedRowKeysData(selectedRowKeys);
                                                  // console.log("A",selectedRows);
                                                  // console.log("B",selectedRowKeys);
                                                  const row = selectedRows
                                                    ? selectedRows
                                                    : [];
                                                  const parseRow = row.map(data => data._id)
                                                  setGenerate({
                                                    ...generate,
                                                    dn:parseRow,
                                                  });
                                                },
                                                getCheckboxProps: (record) => {
                                                  var checkDisable = selectedRowsData
                                                    ? selectedRowsData[0]
                                                    : null;
                          
                                                  return {
                                                    disabled:
                                                        (record.dn_no == '-'),
                                                  };
                                                },
                          
                                                columnTitle: selectedRowsData.length > 0 ? "" : <></>,
                                              }}
                                            expandable={{
                                                expandedRowRender: renderColumnDetail,
                                                onExpandedRowsChange: (data) => handleChangeDetails(data),
                                                expandedRowKeys: rowDetails,
                                            }}
                                            size="small"
                                            dataSource={dataHead}
                                            rowKey={(data) => data._id}
                                            onChange={handleTableChange}
                                            pagination={{
                                                pageSize: pageSize,
                                                total: totalHead,
                                                showSizeChanger: false,
                                            }}
                                            loading={loading}
                                            />
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </Content>
        </Fragment>
    );
}

export default SPTransformBeforePaint;
